import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

interface StatTileProps {
    label: string;
    value: number | undefined;
    isLoading: boolean;
    isError: boolean;
}

export function StatTile({ label, value, isLoading, isError }: StatTileProps) {
    return (
        <Paper sx={{ p: 3, flex: '1 1 220px', minWidth: 220 }}>
            <Typography variant="body2" color="text.secondary">
                {label}
            </Typography>
            {isLoading ? (
                <Skeleton variant="text" width={80} height={56} />
            ) : isError ? (
                <Typography variant="h3" color="text.disabled" sx={{ fontWeight: 600 }}>
                    —
                </Typography>
            ) : (
                <Typography variant="h3" sx={{ fontWeight: 600 }}>
                    {value}
                </Typography>
            )}
        </Paper>
    );
}
